import {
  Box,
  Typography,
 } from '@mui/material';

// ----------------------------------------------------------------------

export default function CircleNumber({ sx, variant = "subtitle2", color = "common.white", backgroundColor = "secondary.main", number = 1 }) {
  return (
    <Box sx={{
      borderRadius: 2,
      backgroundColor: backgroundColor,
      color: color,
      width: 24,
      height: 24,
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      ...sx,
    }}>
      <Typography variant={variant}>
        {number}
      </Typography>
    </Box>
  );
}
